/**
 * ENFAMI — préférence devise (USD / CAD / EUR)
 * Ne force PLUS de redirection auto vers USD (évite une 2ᵉ navigation au 1er chargement).
 * Mémorise uniquement le choix utilisateur pour les chips.
 */
(function () {
  'use strict';

  var PREF_KEY = 'enfami_currency_pref';

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-ef-set-country]');
    if (!chip) return;
    var iso = chip.getAttribute('data-ef-set-country');
    if (!iso) return;
    /* US → USD ; CA → CAD ; FR/DE/… → code pays (EUR Markets) */
    if (iso === 'US') localStorage.setItem(PREF_KEY, 'USD');
    else if (iso === 'CA') localStorage.setItem(PREF_KEY, 'CAD');
    else localStorage.setItem(PREF_KEY, iso);
  });
})();
